export const motivationQuestions = [
  {
    id: 1,
    text_fr: "Pensez-vous que dans 6 mois vous ne fumerez plus ?",
    text_en: "Do you think that in 6 months you will no longer smoke?",
    options: [
      { label_fr: "Oui", label_en: "Yes", points: 2 },
      { label_fr: "Peut-être", label_en: "Maybe", points: 1 },
      { label_fr: "Non", label_en: "No", points: 0 }
    ]
  },
  {
    id: 2,
    text_fr: "Avez-vous envie d'arrêter de fumer ?",
    text_en: "Do you want to quit smoking?",
    options: [
      { label_fr: "Oui, beaucoup", label_en: "Yes, very much", points: 2 },
      { label_fr: "Oui, un peu", label_en: "Yes, a little", points: 1 },
      { label_fr: "Non", label_en: "No", points: 0 }
    ]
  },
  {
    id: 3,
    text_fr: "Pensez-vous que vous arriverez à ne plus fumer dans les semaines qui viennent ?",
    text_en: "Do you think you will be able to stop smoking in the coming weeks?",
    options: [
      { label_fr: "Oui", label_en: "Yes", points: 2 },
      { label_fr: "Peut-être", label_en: "Maybe", points: 1 },
      { label_fr: "Non", label_en: "No", points: 0 }
    ]
  },
  {
    id: 4,
    text_fr: "Pensez-vous que le tabac soit vraiment dangereux pour votre santé ?",
    text_en: "Do you think tobacco is really dangerous for your health?",
    options: [
      { label_fr: "Oui, absolument", label_en: "Yes, absolutely", points: 2 },
      { label_fr: "Un peu", label_en: "A little", points: 1 },
      { label_fr: "Non, pas vraiment", label_en: "No, not really", points: 0 }
    ]
  },
  {
    id: 5,
    text_fr: "Avez-vous déjà essayé d'arrêter de fumer ?",
    text_en: "Have you ever tried to quit smoking?",
    options: [
      { label_fr: "Oui, plusieurs fois", label_en: "Yes, several times", points: 2 },
      { label_fr: "Oui, une fois", label_en: "Yes, once", points: 1 },
      { label_fr: "Non, jamais", label_en: "No, never", points: 0 }
    ]
  },
  {
    id: 6,
    text_fr: "Êtes-vous prêt(e) à faire des efforts pour arrêter ?",
    text_en: "Are you ready to make efforts to quit?",
    options: [
      { label_fr: "Oui, tous les efforts nécessaires", label_en: "Yes, all necessary efforts", points: 2 },
      { label_fr: "Oui, quelques efforts", label_en: "Yes, some efforts", points: 1 },
      { label_fr: "Non, pas vraiment", label_en: "No, not really", points: 0 }
    ]
  },
  {
    id: 7,
    text_fr: "Avez-vous un soutien de votre entourage pour arrêter ?",
    text_en: "Do you have support from your family/friends to quit?",
    options: [
      { label_fr: "Oui, beaucoup", label_en: "Yes, a lot", points: 2 },
      { label_fr: "Oui, un peu", label_en: "Yes, a little", points: 1 },
      { label_fr: "Non, pas du tout", label_en: "No, not at all", points: 0 }
    ]
  },
  {
    id: 8,
    text_fr: "Quelle est votre principale motivation pour arrêter ?",
    text_en: "What is your main motivation to quit?",
    options: [
      { label_fr: "Ma santé", label_en: "My health", points: 2 },
      { label_fr: "L'argent / Mon entourage", label_en: "Money / Family", points: 1 },
      { label_fr: "Je ne suis pas motivé(e)", label_en: "I'm not motivated", points: 0 }
    ]
  }
];

export const getMotivationInterpretation = (score, language) => {
  if (score >= 14) {
    return {
      level: language === 'fr' ? 'Motivation très élevée' : 'Very high motivation',
      color: 'score-very-low',
      bgColor: 'bg-green-100',
      textColor: 'text-green-800',
      message: language === 'fr' 
        ? "Excellent ! Vous êtes très motivé(e) pour arrêter de fumer. C'est le moment idéal pour passer à l'action !"
        : "Excellent! You are highly motivated to quit smoking. This is the perfect time to take action!"
    };
  } else if (score >= 10) {
    return {
      level: language === 'fr' ? 'Bonne motivation' : 'Good motivation',
      color: 'score-low',
      bgColor: 'bg-green-200',
      textColor: 'text-green-900',
      message: language === 'fr'
        ? "Vous avez une bonne motivation. Avec un peu de soutien, vous pouvez réussir à arrêter."
        : "You have good motivation. With some support, you can succeed in quitting."
    };
  } else if (score >= 6) {
    return {
      level: language === 'fr' ? 'Motivation moyenne' : 'Medium motivation',
      color: 'score-medium',
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-800',
      message: language === 'fr'
        ? "Votre motivation est modérée. Réfléchissez aux raisons qui vous poussent à arrêter."
        : "Your motivation is moderate. Think about the reasons that drive you to quit."
    };
  } else if (score >= 3) {
    return {
      level: language === 'fr' ? 'Motivation faible' : 'Low motivation',
      color: 'score-high',
      bgColor: 'bg-orange-100',
      textColor: 'text-orange-800',
      message: language === 'fr'
        ? "Votre motivation est faible. Prenez le temps de réfléchir aux bénéfices de l'arrêt du tabac."
        : "Your motivation is low. Take time to think about the benefits of quitting."
    };
  } else {
    return {
      level: language === 'fr' ? 'Motivation très faible' : 'Very low motivation',
      color: 'score-very-high',
      bgColor: 'bg-red-100',
      textColor: 'text-red-900',
      message: language === 'fr'
        ? "Vous n'êtes pas encore prêt(e) à arrêter. C'est normal, le changement prend du temps."
        : "You are not ready to quit yet. That's normal, change takes time."
    };
  }
};
